

// IntersectionObserver 监听元素是否出现在可视区域
export const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        // entry.isIntersecting 为true 就是出现在页面中了
        if (entry.isIntersecting) {
            // target 就是当前的元素
            const target = entry.target;
            const classList = Array.from(target.classList)
            target.classList.add('animate__animated')
            if (classList.includes('fadeInDown')) {
                target.classList.add('animate__fadeInDown');
            } else if (classList.includes('fadeInUp')) {
                target.classList.add('animate__fadeInUp');
            } else if (classList.includes('fadeInLeft')) {
                target.classList.add('animate__fadeInLeft');
            } else if (classList.includes('fadeInRight')) {
                target.classList.add('animate__fadeInRight');
            } else if (classList.includes('backInUp')) {
                target.classList.add('animate__backInUp');
            } else if (classList.includes('backInLeft')) {
                target.classList.add('animate__backInLeft');
            } else if (classList.includes('backInRight')) {
                target.classList.add('animate__backInRight');
            } else if (classList.includes('zoomIn')) {
                target.classList.add('animate__zoomIn'); //放大
            }

            if (classList.includes('delay-1s')) {
                target.classList.add('animate__delay-1s');
            } else if (classList.includes('delay-2s')) {
                target.classList.add('animate__delay-2s');
            }
        }
    });
});
